import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const AgreePopup = (props) => {
    const { popupCancel } = usePageMessages();
    return (
        <SimplePopup text={<div data-testid="agree-popup-p-text">{props.text}</div>} popupRef={props.popupRef}>
            <PopupButton
                dataTestId="agree-popup-link-agree"
                iconName="check"
                text={props.agreeButton}
                onClick={(e) => {
                    if (props.agreeHandler) {
                        props.agreeHandler(e);
                    }
                }}
            />
            <PopupButton
                dataTestId="agree-popup-link-cancel"
                iconName="cross"
                text={popupCancel}
                onClick={(e) => {
                    props.popupRef.current?.close();
                    e.preventDefault();
                }}
            />
        </SimplePopup>
    );
};

export default AgreePopup;
